<template>
	<div class="">
		<div class="row">
			<div class="col-md-12">
				<div class="row">
					<div class="col-md-12 mb-3">
						<el-card shadow="hover">
							<h5 class="m-0"><i class="fa fa-bar-chart" aria-hidden="true"></i>&nbsp;&nbsp;PROPERTY MANAGEMENT IFCA</h5>
						</el-card>
					</div>
				</div>

				<div class="row">
					<div class="col-md-4 mb-4">
						<el-card shadow="hover">
							<div slot="header" class="clearfix">
								<h6 class="text-center m-0">INVOICE {{ year }}</h6>
							</div>
							<div>
								<BarChart v-loading.body="loading.ifca" :data="chartdataifcainvoice" :width="500" :height="350" v-if="showchartproman"/>
							</div>
						</el-card>
					</div>

					<div class="col-md-4 mb-4">
						<el-card shadow="hover">
							<div slot="header" class="clearfix">
								<h6 class="text-center m-0">TOTAL TENANT {{ year }}</h6>
							</div>
							<div>
								<BarChart v-loading.body="loading.ifca" :data="chartdataifcatotalcontract" :width="500" :height="350" v-if="showchartproman"/>
							</div>
						</el-card>
					</div>
				</div>

				<!--
				<div class="row" v-if="false">
					<div class="col-md-12 mb-4">
						<el-card shadow="hover">
							<div slot="header" class="clearfix">
								<h6 class="text-center m-0">EXPIRED CONTRACT ALERT</h6>
							</div>
							<div>
								<div class="table-nfr-container">
									<table class="table-nfr">
										<thead class="top-header-1">
											<tr>
												<th>No</th>
												<th>Tenan</th>
												<th>Akhir Sewa</th>
												<th class="text-left">Lokasi</th>
												<th>Sales Area</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(item,idx) in reportdata?.data?.contract_alert" :key="idx+'_'+item.StationId">
												<td class="text-center">{{ ++idx }}</td>
												<td>{{ item.NamaPengelolaToko }}</td>
												<td class="text-center">{{ item.TanggalAkhirSewa }}</td>
												<td>{{ item.StationName }}</td>
												<td class="text-center">{{ item.SalesArea }}</td>
											</tr>
										</tbody>
									</table>
									<Loader v-if="loading.ifca"/>
								</div>
							</div>
						</el-card>
					</div>

				</div>
			-->

			</div>
		</div>
	</div>
</template>

<script>
import BarCard from '@/views/pages/BarCard.vue'
import { Rainbow, FuelColor, Penanggalan, AppColors, AxiosWithJar, Config} from '@/utility.js'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import Loader from '@/components/loader/Loader2.vue'

import PiechartCardview from '@/views/pages/PropertyManagement/Component/PiechartCardview.vue'

export default{
	extends: Fuel,
	components:{
		//ListItem,
		//ListCompare, //
		//BarCard,
		//PieChart,
		BarChart,
		//PiechartCardview,
		//Footer,
		//Loader
	},
	props: {
        plant: {
            type: String,
            default: '',
            //required: false,
        },
        station: {
            type: String,
            default: '',
            //required: false,
        },
		unitids: {
            type: Array,
            default() {
                return [];
            }
            //default: () => [],
            //required: false,
        },
		showchartproman: {
			type: Boolean,
			default: false,
		},
    },
	data() {
		return {
            value: 0,
			chartdataifcainvoice: [],
			//chartdataifcacontractalert: [],
			chartdataifcatotalcontract: [],
			//chartdataifcacontractprice: [],
			stacked: false,
			loading: {
				ifca: false,
			},
			year: Penanggalan().tahun,

		}
	},
	watch: {
		station() {
			this.getOverviewData();
		},
	},
	computed: {

	},

    mounted() {
		//this.getOverviewData();
    },
    methods:{
		async getOverviewData() {
			this.urlRequestParams = Config().apiURL

            this.urlRequestParams += '/v1/nfr/ifcaoverviewbusinessunit?'
			this.urlRequestParams += "&station="+this.station
			this.urlRequestParams += "&plant="+this.plant

            this.loading.ifca = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					//this.loading.isSuccess = true;
					this.reportdata = response.data;

                    if(this.reportdata) {
						this.chartdataifcainvoice = this.setBarchart(this.reportdata.data.chart.invoice, "MonthName", "Label", "TotalInvoice");
						//this.chartdataifcacontractalert = this.setBarchart(this.reportdata.data.chart.contract_alert, "Label", "SalesArea", "Cnt");
						this.chartdataifcatotalcontract = this.setBarchart(this.reportdata.data.chart.tenant, "StationName", "Label", "TenantCount");
						//this.chartdataifcacontractprice = this.setBarchart(this.reportdata.data.chart.contract_price, "SalesArea", "PriceCategory", "Value");

						this.redrawChart();
					}

				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.ifca = false;
				})
        },

		setBarchart(data, label, legend, valuecol) {
			return this.processBarChart(data, legend, "", valuecol, false, label, "", 1, 2, AppColors, false, false, false, this.stacked);
		},

		redrawChart() {
            this.showchartproman = false
            setTimeout(() => {
                this.showchartproman = true
                //console.log('Redraw chart growth')
            }, 500);
        },
	}
}
</script>

<style>

.table-nfr-container {
  /*max-width: 500px; */
  width: 100%;
  margin: auto;
  margin-top: 0rem;
  overflow-x: auto;
  max-height: 350px;
}

.table-nfr {
  font-family: "Open Sans", sans-serif;
  position: relative;
  border-collapse: initial; /**collapse */
  border-spacing: 0;
  table-layout: auto;
  width: 100%;
  border: none;
  border-radius: 0rem;
  /*box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);*/
  white-space: nowrap;
}

.table-nfr thead th {
  /*background: #edf2f7; */ /* $gray-200 */
  padding: 0.45rem 1.5rem;
  vertical-align: middle;
  text-align: center;
  border: 1px solid white;
  border-left: 0px solid white;
  border-top: 0px solid white;
  border-bottom: 1px solid #F0F0F0;
  background: white;
}

.top-header-1 {
    position: -webkit-sticky; /* For Safari */
    position: sticky;
    top: 0;
    z-index: 2;
}

.top-header-2 {
    position: -webkit-sticky; /* For Safari */
    position: sticky;
    top: 70;
    z-index: 2;
}

.table-nfr thead th:first-child {
    z-index: 4;
}

.table-nfr th:first-child {
  border-top-left-radius: 0rem;
}

.table-nfr th:last-child {
  border-top-right-radius: 0rem;
}


.table-nfr thead tr {
  color: #2d3748; /* $gray-800 */
  font-size: 1rem;
  font-weight: 500;
  text-align: left;
}

.table-nfr tbody tr:nth-child(odd) td {
  background: #ffffff; /* $white */
}

.table-nfr tbody tr:nth-child(even) td {
  background: #FAFBFC /*#edf2f7*/; /* $gray-200 */
}

.table-nfr tbody tr:hover {
  background-color: #e2e8f0 !important; /**e2e8f0 */
}

.table-nfr tbody tr:hover td {
  background-color: #e2e8f0;
}

.table-nfr tbody td {
  color: #1a202c; /* $gray-900 */
  text-align: left;
  padding: 0.4rem 0.5rem;
  vertical-align: middle;
  font-size: 0.925rem;
  font-weight: normal;
  border:0px solid #F0F0F0;
  border-left:0px solid #F0F0F0;
}

.table-nfr tr:last-child td:first-child {
  border-bottom-left-radius: 0rem;
}

.table-nfr tr:last-child td:last-child {
  border-bottom-right-radius: 0rem;
}

.table-nfr tr > th:first-child,
.table-nfr tr > td:first-child {
  position: sticky;
  left: 0;
}


.table-nfr-container::-webkit-scrollbar {
  width: 8px; /* Width of the scrollbar */
}

.table-nfr-container::-webkit-scrollbar-track {
  background: #f1f1f1; /* Background of the scrollbar track */
}

.table-nfr-container::-webkit-scrollbar-thumb {
  background: #A8A8A8; /* Color of the scrollbar thumb */
  border-radius: 6px; /* Roundness of the scrollbar thumb */
}

.table-nfr-container::-webkit-scrollbar-thumb:hover {
  background: #555; /* Color of the scrollbar thumb when hovered */
}

/* For Firefox */
.table-nfr-container {
  scrollbar-width: thin; /* Sets the width of the scrollbar */
  scrollbar-color: #A8A8A8 #f1f1f1; /* Sets the color of the thumb and track */
}

</style>
